export enum UserAgentBrowser {
  Chrome = 'Chrome',
  Firefox = 'Firefox',
  Safari = 'Safari',
  Opera = 'Opera',
  Edge = 'Edge',
  Brave = 'Brave',
  Arc = 'Arc',
  Vivaldi = 'Vivaldi',
  InternetExplorer = 'Internet Explorer',
  Unknown = 'Unknown',
}
